import { Link, useLocation } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { routes } from "sitemap";
import { useAdminRolePermissions } from "permissions/AdminRolePermissionGate";
import {
  CATEGORY_ICONS,
  getActiveModule,
  getActivePage,
  moduleTarget,
} from "../navUtils";

/* =====================================================================
   Level-1 navigation — centered module tabs with hover flyouts.
   Each multi-page module reveals its sub-sections in a flyout on hover /
   keyboard focus. The active module uses the primary accent + underline.
   ===================================================================== */

const ModuleTopNav = () => {
  const { filterSitemapRoutesByPermissions } = useAdminRolePermissions();
  const { pathname } = useLocation();

  const modules = filterSitemapRoutesByPermissions(routes).filter(
    (r) => r.pages && r.pages.length > 0
  );
  const activeModule = getActiveModule(modules, pathname);
  const activePage = getActivePage(activeModule, pathname);

  if (!modules.length) return null;

  return (
    <nav className="ab-topnav" aria-label="Primary">
      {modules.map((m, i) => {
        const isActive = m === activeModule;
        const pages = m.pages || [];
        const multi = pages.length > 1;

        return (
          <div className="ab-nav-item-wrap" key={i}>
            <Link
              to={moduleTarget(m)}
              className={`ab-nav-item${isActive ? " active" : ""}`}
              aria-haspopup={multi ? "true" : undefined}
              onClick={(e) => e.currentTarget.blur()}
            >
              <span>{m.label}</span>
              {multi && (
                <FeatherIcon
                  icon="chevron-down"
                  size={14}
                  className="ab-nav-caret"
                />
              )}
            </Link>

            {multi && (
              <div className="ab-nav-flyout" role="menu">
                <div className="ab-nav-flyout-card">
                  <div className="ab-nav-flyout-title">{m.label}</div>
                  {pages.map((p, j) => {
                    const pageActive = isActive && p === activePage;
                    return (
                      <Link
                        key={j}
                        to={p.path || "#!"}
                        role="menuitem"
                        className={`ab-nav-flyout-item${
                          pageActive ? " active" : ""
                        }`}
                        onClick={(e) => e.currentTarget.blur()}
                      >
                        <span className="ab-nav-flyout-ic">
                          <FeatherIcon
                            icon={
                              typeof p.icon === "string" ? p.icon : "circle"
                            }
                            size={16}
                          />
                        </span>
                        <span>{p.name}</span>
                      </Link>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default ModuleTopNav;
